export default __webpack_public_path__ + "static/media/skank-gris.786162e7.jpg";